import React, { useEffect, useState } from "react";
import ConfigData from "../../master/components/ConfigData";
import { Checkbox, Button, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, } from "@material-ui/core";
import { DeletePopUp, EmptyCollection, ExportMenu, FilterComponent, ImportMenu, PageLoader, Pagination, RevisionHistory, STableLoader, } from "../../../shared_elements";
import { globalDeleteService, globalExportService, globalGetService, globalPutService } from "../../../../globalServices";
import { checkApiStatus ,checkPermission} from "../../../utils_v2";
import EngineFamilyList from "../component/EngineFamilyList";
import AddEditEngineFamily from "../component/AddEditEngineFamily";
import { trackActivity } from "../../../../utils/mixpanel";
import { useSnackbar } from "notistack";
import AddIcon from '@material-ui/icons/Add';
import { usePageTitleOffset } from '../../../elements/CollapsibleSideNav';

const EngineFamilyObj = {
    name: null,
    manufacturer: null,
    remarks: null
}

const EngineListHeader = ({ handleSelectAll, isSelectAllChecked, createSortHandler, sortInfo }) => {
    return (
        <TableHead>
            <TableRow>
                <TableCell >{ checkPermission('config_data', 'engine_family', 'D') &&<Checkbox checked={isSelectAllChecked} onChange={handleSelectAll} color="primary" size="small" />}Action(s)</TableCell>
                <TableCell >
                    <TableSortLabel
                        active={sortInfo.sort === 'name' ? true : false}
                        direction={sortInfo.sort === 'name' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('name')}
                    >
                        Name
                    </TableSortLabel>
                </TableCell>
                <TableCell >
                    <TableSortLabel
                        active={sortInfo.sort === 'manufacturer' ? true : false}
                        direction={sortInfo.sort === 'manufacturer' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('manufacturer')}
                    >
                        Manufacturer
                    </TableSortLabel>
                </TableCell>
                <TableCell >
                    <TableSortLabel
                        active={sortInfo.sort === 'created_by' ? true : false}
                        direction={sortInfo.sort === 'created_by' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('created_by')}
                    >
                        Created By
                    </TableSortLabel>
                </TableCell>
                <TableCell >
                    <TableSortLabel
                        active={sortInfo.sort === 'updated_by' ? true : false}
                        direction={sortInfo.sort === 'updated_by' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('updated_by')}
                    >
                        Last Updated By
                    </TableSortLabel>
                </TableCell>
                <TableCell >
                    <TableSortLabel
                        active={sortInfo.sort === 'remarks' ? true : false}
                        direction={sortInfo.sort === 'remarks' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('remarks')}
                    >
                        Remarks
                    </TableSortLabel>
                </TableCell>
            </TableRow>
        </TableHead >
    )
}

const EngineFamily = () => {
    const navTitleOffset = usePageTitleOffset('configDataNavCollapsed');

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState({});
    const [pageSelections, setPageSelections] = useState({});
    const [currentPage, setCurrentPage] = useState({});
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [bulkDelete, setBulkDelete] = useState({ modal: false, data: null })
    const [bulkRevert, setBulkRevert] = useState({ modal: false, data: null })
    const [addEditEngineFamily, setAddEditEngineFamily] = useState({ modal: false, data: null });
    const [deleteEngineFamily, setDeleteEngineFamily] = useState({ modal: false, data: null });
    const [revertEngineFamily, setRevertEngineFamily] = useState({ modal: false, data: null });
    const [engineFamilyInfo, setEngineFamilyInfo] = useState({list:[], pagination:{}});
    const [manufacturersFilter, setManufacturersFilter] = useState([]);

    useEffect(() => {
        getEngineFamily({per_page:50},"skeletonLoader");
        trackActivity('Console Management', { page_title: 'Config Data : Engine Family', event_type: 'Page Visited' })
        getManufacturers()
    }, [])

    const getEngineFamily = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`config-data/engine-families/`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setEngineFamilyInfo(response.data.data)
                    if(query){
                        delete query.page
                        delete query.per_page
                        delete query.sort
                        delete query.sort_by
                        setFilter(query)
                    }
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }
    
    const toggleBulkOps = (item, checked, currentPage) => {
        setPageSelections(prevSelections => {
            const updatedSelections = { ...prevSelections };
            if (checked) {
                updatedSelections[currentPage] = updatedSelections[currentPage] || [];
                updatedSelections[currentPage].push(item?.id);
            } else {
                updatedSelections[currentPage] = updatedSelections[currentPage]?.filter(id => id !== item?.id);
            }
            return updatedSelections;
        });
    };

    const onDelete = () => {
        setLoading(true)
        const ids = !deleteEngineFamily.data ? Object.values(pageSelections).flat().filter(id => {
            const item = engineFamilyInfo.list.find(item => item.id === id);
            return item && !item.deleted_at;
        }) : deleteEngineFamily.data.id

        globalDeleteService(`config-data/engine-families/bulk-delete/`, { ids })
            .then(response => {
                if (checkApiStatus(response)) {
                    setDeleteEngineFamily({ modal: false, data: null });
                    getEngineFamily({...filter, page: engineFamilyInfo?.pagination?.page, per_page: engineFamilyInfo?.pagination?.per_page}, 'pageLoader');
                    setCurrentPage({});
                    setLoading(false)
                    setBulkDelete({ modal: false, data: null })
                    setPageSelections({});
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Engine Family',
                        event_type: `Item Deleted`,
                        event_desc: 'Engine Family Deleted Successfully',
                        success_msg: response?.data?.message,
                        deleted_id: ids
                    });
                } else {
                    setDeleteEngineFamily({ modal: false, data: null });
                    setLoading(false)
                    setPageSelections({});
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    setBulkDelete({ modal: false, data: null })
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Engine Family',
                        event_type: `Item Deleted`,
                        event_desc: 'Engine Family Deletion Failed',
                        error_msg: response?.data?.message,
                        item_id: ids
                    });
                }
            });
    };

    const onRevert = () => {
        setLoading(true)
        const ids = !revertEngineFamily.data ? Object.values(pageSelections).flat().filter(id => {
            const item = engineFamilyInfo.list.find(item => item.id === id);
            return item && item.deleted_at;
        }) : revertEngineFamily.data;

        globalPutService(`config-data/engine-families/restore/`, { ids })
            .then(response => {
                if (checkApiStatus(response)) {
                    setRevertEngineFamily({ modal: false, data: null });
                    getEngineFamily({...filter, page: engineFamilyInfo?.pagination?.page, per_page: engineFamilyInfo?.pagination?.per_page}, 'pageLoader');
                    setCurrentPage({});
                    setLoading(false)
                    setPageSelections({});
                    setBulkRevert({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Engine Family',
                        event_type: `Item Reverted`,
                        event_desc: 'Engine Family Reverted Successfully',
                        success_msg: response?.data?.message,
                        reverted_id: ids
                    });
                } else {
                    setRevertEngineFamily({ modal: false, data: null });
                    setLoading(false)
                    setPageSelections({});
                    setBulkRevert({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Engine Family',
                        event_type: `Item Reverted`,
                        event_desc: 'Engine Family Reversion Failed',
                        error_msg: response?.data?.message,
                        item_id: ids
                    });
                }
            });
    };

    const handleSelectAll = (event, currentPage) => {
        if (event?.target.checked) {
            const allIds = engineFamilyInfo?.list.map(item => item.id);
            setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: allIds }));
        } else {
            setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: [] }));
        }
    };

    const getFilteredSelectionCounts = () => {
        let deleteCount = 0;
        let revertCount = 0;

        if (pageSelections[currentPage]?.length) {
            pageSelections[currentPage].forEach(id => {
                const selectedItem = engineFamilyInfo?.list?.find(item => item?.id === id);
                if (selectedItem) {
                    if (selectedItem?.deleted_at) {
                        revertCount++;
                    } else {
                        deleteCount++;
                    }
                }
            });
        }
        return { deleteCount, revertCount };
    };

    const { deleteCount, revertCount } = getFilteredSelectionCounts();

    const createSortHandler = (key) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort_by: 'asc' }
        }
        setSortInfo(sortQuery)
        getEngineFamily({ ...filter, ...sortQuery, page: 1, per_page: engineFamilyInfo?.pagination?.per_page || 20 }, 'pageLoader');
    }

    const isSelectAllChecked = engineFamilyInfo?.list?.length > 0 && pageSelections[currentPage]?.length === engineFamilyInfo?.list?.length;

    const getConfirmColor = () => {
        if (revertEngineFamily?.modal || bulkRevert?.modal) return "primary";
        if (deleteEngineFamily?.modal || bulkDelete?.modal) return "secondary";
        return "";
    };

    const getConfirmText = () => {
        if (revertEngineFamily?.modal || bulkRevert?.modal) return "Revert";
        if (deleteEngineFamily?.modal || bulkDelete?.modal) return "DELETE";
        return "";
    };

    const getModal = () => {
        if (revertEngineFamily?.modal) return revertEngineFamily.modal;
        if (deleteEngineFamily?.modal) return deleteEngineFamily.modal;
        if (bulkDelete?.modal) return bulkDelete.modal;
        if (bulkRevert?.modal) return bulkRevert.modal;
        return null;
    };

    const getTitle = () => {
        if (revertEngineFamily?.modal) return "Revert Engine Family";
        if (deleteEngineFamily?.modal) return "Delete Engine Family";
        if (bulkDelete?.modal) return `Delete Engine Family (${deleteCount})`;
        if (bulkRevert?.modal) return `Revert Engine Family (${revertCount})`;
        return "";
    };

    const getContent = () => {
        if (revertEngineFamily?.modal || bulkRevert?.modal)
            return "Are you sure, you want to Revert?";
        if (deleteEngineFamily?.modal || bulkDelete?.modal)
            return "Are you sure, you want to Delete?";
        return "";
    };

    const toggleModalFn = () => {
        if (revertEngineFamily?.modal) {
            setRevertEngineFamily({ modal: false, data: null });
        } else if (deleteEngineFamily?.modal) {
            setDeleteEngineFamily({ modal: false, data: null });
        } else if (bulkDelete?.modal) {
            setBulkDelete({ modal: false, data: null });
        } else {
            setBulkRevert({ modal: false, data: null });
        } 
    };


    const getDeleteRecordFn = () => {
        if (revertEngineFamily?.modal || bulkRevert?.modal) return onRevert;
        if (deleteEngineFamily?.modal || bulkDelete?.modal) return onDelete;
        return null;
    };
    const getManufacturers = () => {
        globalGetService(`config-data/manufacturers/?lite=true`)
            .then(response => {
                if (checkApiStatus(response)) {
                    let manufacturersFilter = [];
                    const data = response?.data?.data;
                    data && data.map((item) => {
                        manufacturersFilter.push({ id: item?.id, name: item?.name })
                    });
                    setManufacturersFilter(manufacturersFilter);
                }
            })
    }
    const filterOption = (
        {
            'name': {
                'inputType': 'text',
                'title': 'Name',
            },
            'manufacturer': {
                'inputType': 'dropdown',
                'title': 'Manufacturer',
                'options': manufacturersFilter,
                'labelKey': 'name',
                'valueKey': 'id',
            },
        })

    return (
        <section className="asset-tech-specs" style={{ margin: '25px 0 0 75px' }}>
            <Paper elevation={0} className="tech-specs-card console-paper" style={{ height: `${window.innerHeight - 89}px` }}>
                <ConfigData />
                <div className="tech-specs-content" style={{ paddingTop: '0px' }}>
                    {skeletonLoader ? <STableLoader count={6} size={9} /> :
                    <div style={{ padding: '10px' }}>
                        <Paper elevation={0} className="console-paper" style={{ padding: '5px 10px', marginBottom: "2px" }}>
                            <Grid container spacing={1} alignItems="center">
                                <Grid item md={6}>
                                        <FilterComponent
                                            filter={filter}
                                            filterMenu={filterOption}
                                            getResponseBack={(applyFilter) => { getEngineFamily({ ...applyFilter, page: 1, per_page: engineFamilyInfo?.pagination?.per_page || 10 }, 'pageLoader') }}
                                        />
                                </Grid>
                                <Grid item md={6}>
                                    <ul className='list-inline flex-centered' style={{ float: 'right' }}>
                                        {revertCount > 0 && (
                                            <li className='list-inline-item'>
                                                <Button onClick={() => { setBulkRevert({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Engine Family', item_type: 'Bulk Revert', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Revert Modal from Engine Family` }) }} color="primary" size='small' variant="outlined">
                                                    Revert ({revertCount})
                                                </Button>
                                            </li>
                                        )}
                                        {deleteCount > 0 && (
                                            <li className='list-inline-item'>
                                                <Button onClick={() => { setBulkDelete({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Engine Family', item_type: 'Bulk Delete', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Delete Modal from Engine Family` }) }} color="secondary" size='small' variant="contained">
                                                    Delete ({deleteCount})
                                                </Button>
                                            </li>
                                        )}
                                        {checkPermission('config_data', 'engine_family', 'C') && <li className='list-inline-item'>
                                            <Button onClick={() => setAddEditEngineFamily({ modal: true, data: EngineFamilyObj, type: 'add' })} color="primary" size='small' variant="contained"><AddIcon style={{ fontSize: '1.15rem' }} />ADD</Button>
                                        </li>
                                        }

                                        <li className='list-inline-item' style={{ cursor: 'pointer' }}>
                                            <RevisionHistory isExp={false} buttonType={true} url={`audit/config-data/cdenginefamilies/`} queryParams={{ action: '0,1,2' }} />
                                        </li>
                                    </ul>
                                </Grid>
                            </Grid>
                        </Paper>

                        <Paper square>
                         <div style={{ height: `${(window.innerHeight - (engineFamilyInfo?.list?.length ? 200 : 150)) - navTitleOffset}px`, overflow: 'auto' }}>
                            <Table className="mui-table-format" stickyHeader>
                                <EngineListHeader isSelectAllChecked={isSelectAllChecked} handleSelectAll={(e) => handleSelectAll(e, currentPage)} createSortHandler={createSortHandler} sortInfo={sortInfo} />
                                    <TableBody>
                                    {engineFamilyInfo?.list?.length > 0 && engineFamilyInfo?.list?.map((item, index) =>
                                        <EngineFamilyList
                                            item={item}
                                            index={index}
                                            onDelete={setDeleteEngineFamily}
                                            onRevert={setRevertEngineFamily}
                                            onEditFn={() => setAddEditEngineFamily({ modal: true, data: item, type: 'edit' })}
                                            toggleBulkOps={(item, checked) => toggleBulkOps(item, checked, currentPage)}
                                            bulkIds={pageSelections[currentPage] || []}
                                        />
                                    )}
                                    </TableBody>
                             </Table>
                             {!engineFamilyInfo?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                             </div>
                        </Paper>
                        <Paper square>
                            <Pagination
                                pagination={engineFamilyInfo?.pagination}
                                onChangePage={(event, newPage) => { getEngineFamily({ ...filter, page: newPage + 1, per_page: engineFamilyInfo.pagination?.per_page, sort_by: sortInfo?.sort_by, sort: sortInfo?.sort }, 'pageLoader'); setCurrentPage(newPage + 1) }}
                                onChangeRowsPerPage={(event) => getEngineFamily({ ...filter, page: 1, per_page: event.target.value, sort_by: sortInfo?.sort_by, sort: sortInfo?.sort }, 'pageLoader')}
                            />
                        </Paper>
                    </div>}
                </div>
                {addEditEngineFamily.modal ?
                    <AddEditEngineFamily
                        addEditEngineFamily={addEditEngineFamily}
                        engineFamilyInfo={engineFamilyInfo}
                        toggleModalFn={() => setAddEditEngineFamily({ modal: false, region: [] })}
                        getResponseBack={() => getEngineFamily({...filter, page: engineFamilyInfo?.pagination?.page, per_page: engineFamilyInfo?.pagination?.per_page}, 'pageLoader')}
                        modeType={addEditEngineFamily?.type}
                    /> : null
                }
                {}
                <DeletePopUp
                    confirmColor={getConfirmColor()}
                    confirmText={getConfirmText()}
                    modal={getModal()}
                    title={getTitle()}
                    content={getContent()}
                    toggleModalFn={toggleModalFn}
                    deleteRecordFn={getDeleteRecordFn()}
                />
            </Paper>
            {isLoading ? <PageLoader /> : null}
        </section>
    )
}
export default EngineFamily;